import { api } from "../api/api";
import { ApiResponse } from "../models/base/ApiResponse";
import { CreateCityDTO, UpdateCityDTO } from "../models/city/city.request";
import { CitySettingsInfoDTO, CityTableInfoDTO, SelectCityDataDTO } from "../models/city/city.response";


export const cityService = {

    async Create(newCity: CreateCityDTO): Promise<ApiResponse<string>> {
        const { data } = await api.post<ApiResponse<string>>("/cities", newCity);
        return data;
    },

    async Update(id: string, updatedCity: UpdateCityDTO): Promise<ApiResponse<string>> {
        const { data } = await api.patch<ApiResponse<string>>(`/cities/${id}`, updatedCity);
        return data;
    },

    async Delete(id: string): Promise<ApiResponse<string>> {
        const { data } = await api.delete<ApiResponse<string>>(`/cities/${id}`);
        return data;
    },

    async GetForSelect(): Promise<ApiResponse<SelectCityDataDTO[]>> {
        const { data } = await api.get<ApiResponse<SelectCityDataDTO[]>>("/cities/select");
        return data;
    },

    async getTableInfo(): Promise<ApiResponse<CityTableInfoDTO[]>> {
        const { data } = await api.get<ApiResponse<CityTableInfoDTO[]>>("/cities/table");
        return data;
    },

    async GetSettingsInfo(cityId: string): Promise<ApiResponse<CitySettingsInfoDTO>> {
        const { data } = await api.get<ApiResponse<CitySettingsInfoDTO>>(`/cities/${cityId}/settings`);
        return data;
    }

}